Object.defineProperty(exports, "__esModule", { value: true });
exports.salseData = [
  {
    name: "India",
    value1: "3",
    value2: "2",
    country: "India",
  },
  {
    name: "Dominican Rep.",
    value1: "3",
    value2: "2",
    country: "West Indies",
  },
  {
    name: "United States",
    value1: "3",
    value2: "2",
    country: "United States",
  },
  {
    name: "Jamaica",
    value1: "3",
    value2: "2",
    country: "West Indies",
  },
  {
    name: "Haiti",
    value1: "3",
    value2: "2",
    country: "West Indies",
  },
  {
    name: "Guyana",
    value1: "3",
    value2: "2",
    country: "West Indies",
  },
  {
    name: "Suriname",
    value1: "3",
    value2: "2",
    country: "West Indies",
  },
  {
    name: "Trinidad and Tobago",
    value1: "3",
    value2: "2",
    country: "West Indies",
  },
  {
    name: "Sri Lanka",
    value1: "3",
    value2: "1",
    country: "Sri Lanka",
  },
  {
    name: "United Kingdom",
    value1: "3",
    value2: "0",
    country: "England",
  },
  {
    name: "Pakistan",
    value1: "2",
    value2: "1",
    country: "Pakistan",
  },
  {
    name: "New Zealand",
    value1: "1",
    value2: "0",
    country: "New Zealand",
  },
  {
    name: "Australia",
    value1: "7",
    value2: "5",
    country: "Australia",
  },
];
